import type { v2 } from '@deque/billing-service-client';
import React from 'react';
import { getAiCreditSubscription } from '~/common/api-client';
import useAPI, { type State } from '~/common/hooks/useAPI';

const useAICreditSubscription = (
  token: string
): State<v2.EnterpriseSubscription | v2.UserSubscription> => {
  const dataLoader = React.useCallback(
    () => getAiCreditSubscription(token),
    [token]
  );
  return useAPI(dataLoader);
};

export default useAICreditSubscription;
